import { FortifyOAuthStorageFactory } from './auth/fortify/fortify-oauth-storage';
import { LcpTrackerOAuthStorageFactory } from './auth/lcptracker/lcptracker-oauth-storage';
const ɵ0 = LcpTrackerOAuthStorageFactory, ɵ1 = FortifyOAuthStorageFactory;
export class AppModule {
}
export { ɵ0, ɵ1 };
